import uuid from "react-uuid";
let initialState = {
  sectionDetails: {
    sectionKey: "",
    isSectionAdded: false,
  },
  editSectionName: { name: null, id: null },
  addSection: [
    {
      id: null,
      name: null,
      description: null,
      isSectionAdded: false,
      isWidgetAdded: false,
      data: [],
    },
  ],
  templateDetails: {
    templateName: "",
    templateDescription: "",
    templateDuration: null,
    templateFilters: [],
    templateBrands: [],
    dashboard_called_api_list: [],
    hidden_filter: null,
    quick_filter_value: null,
    is_brand_locked: false,
    is_date_locked: false,
  },
  sections: [],
  activeSectionKey: null,
  showMoreSection: null,
  footerValue: {
    replaceThisWidget: null,
    widget: false,
    section: false,
    template: false,
  },
  sectionFilter: null,
  filterObject: {
    id: null,
    type: null,
    section_index: null,
    widget_index: null,
    is_locked: false,
  },
  templateFilterObj: null,
  isEditTemplate: false,
  widgetTitle: {},
  widget_description: null,
  sectionReorderingInprogress: false,
};

const Section = (state = initialState, action) => {
  switch (action.type) {
    case "SET_SECTION_KEY":
      return {
        ...state,
        sectionDetails: action.payload,
      };
    case "SET_ADDSECTION": {
      return {
        ...state,
        addSection: action.payload,
      };
    }
    case "SET_SECTION_REORDER_PROCESSING": {
      return {
        ...state,
        sectionReorderingInprogress: action.payload,
      };
    }
    case "SET_TEMPLATE_DETAILS":
      return {
        ...state,
        templateDetails: action.payload,
      };
    case "SET_SECTIONS":
      return {
        ...state,
        sections: action.payload,
      };
    case "SET_ACTIVE_SECTION_KEY":
      return {
        ...state,
        activeSectionKey: action.payload,
      };

    case "SET_EDIT_SECTION_NAME":
      return {
        ...state,
        editSectionName: action.payload,
      };
    case "SET_FOOTER_VALUE":
      return {
        ...state,
        footerValue: action.payload,
      };
    case "SET_ON_SECTION_FILTER":
      return {
        ...state,
        sectionFilter: action.payload,
      };
    case "SET_FILTER_OBJECT":
      return { ...state, filterObject: action.payload };
    case "SET_TEMPLATE_FILTERS_OBJ":
      return {
        ...state,
        templateFilterObj: action.payload,
      };
    case "SET_EDIT_TEMPLATE":
      return { ...state, isEditTemplate: action.payload };
    case "SET_WIDGET_TITLE":
      return { ...state, widgetTitle: action.payload };
    case "SET_WIDGET_DESCRIPTION":
      return { ...state, widget_description: action.payload };
    default:
      return state;
  }
};

export default Section;
